module.exports = __webpack_public_path__ + "static/media/21ECLAC32.27f681e3.jpg";